/* eslint-disable no-undef */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('dateTime', dateTimeDirective);

    function dateTimeDirective(){
        var directive = {
            require: 'ngModel',
            restrict: 'E',
            template: '<div class="w-full flex items-center flex-wrap sm:flex-no-wrap"><input type="date" ng-disabled="dir.disabled" ng-model="dir.dateTime" class="w-full mb-2"><input type="time" ng-model="dir.dateTime" ng-model-options="{timeSecondsFormat: \'\' }" ng-if="false" class="w-full mb-2 sm:w-1/2 sm:ml-2"></div>',
            replace: true,
            scope: {
                ngModel: '=',
                ngDisabled: '=',
            },
            controllerAs: 'dir',
            controller: DateTimeDirectiveController,

        };

        return directive;

    }

    DateTimeDirectiveController.$inject = ['$scope', 'global', 'load',];

    function DateTimeDirectiveController($scope, global, load){
        var vm = this;
        vm.global = global;

        function activate() {
            if (global.isSafari) {
                var promise = load.loadScript('https://cdn.jsdelivr.net/npm/date-input-polyfill@2.14.0/date-input-polyfill.dist.js');

                promise.then(function() {
                    $scope.$watch('dir.dateTime', buildDateTime);
                    prepare();
                }, function() {});
            } else {
                $scope.$watch('dir.dateTime', buildDateTime);
                prepare();
            }
        }

        function prepare() {
            vm.disabled = $scope.ngDisabled;
            if ($scope.ngModel) {
                var now = moment($scope.ngModel);
                vm.dateTime = now.toDate();
            } else {
                var nowEmpty = moment();
                vm.dateTime = nowEmpty.toDate();
            }
        }

        function buildDateTime(){
            if (!vm.dateTime) {
                vm.dateTime = moment().toDate();
                $scope.ngModel = moment('0000-00-00 00:00:00').format('YYYY-MM-DD HH:mm:ss');
            }
            $scope.ngModel = moment(vm.dateTime).format('YYYY-MM-DD HH:mm:ss');
        }

        activate();
    }


})();